import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PaymentStatus.css";

// Mobile app deep link scheme, e.g. japaking://payment?status=success
const APP_SCHEME = process.env.REACT_APP_DEEP_LINK_SCHEME || "japaking";

const STATUS_CONTENT = {
  success: {
    icon: "✓",
    title: "Payment Successful",
    message: "Your payment has been completed and your plan is now active.",
  },
  failed: {
    icon: "✕",
    title: "Payment Failed",
    message:
      "We could not complete your payment. If any amount was debited, it will be refunded by your bank as per Razorpay timelines.",
  },
  cancelled: {
    icon: "!",
    title: "Payment Cancelled",
    message: "You cancelled the payment. No amount has been charged.",
  },
};

function PaymentStatus({ status }) {
  const location = useLocation();
  const navigate = useNavigate();
  const content = STATUS_CONTENT[status] || STATUS_CONTENT.failed;

  const params = new URLSearchParams(location.search);
  const paymentId = params.get("payment_id") || params.get("razorpay_payment_id");
  const orderId = params.get("order_id") || params.get("razorpay_order_id");

  // App japaking://payment-success | payment-failed | payment-cancelled samajhta hai.
  // razorpay_payment_id app ko na bhejo, warna app dobara /payment/verify call karke duplicate plan bana dega
  params.delete("razorpay_payment_id");
  params.delete("razorpay_order_id");
  params.delete("razorpay_signature");
  params.set("status", status);
  const deepLink = `${APP_SCHEME}://payment-${status}?${params.toString()}`;

  // Try to hand control back to the mobile app automatically
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = deepLink;
    }, 300);
    return () => clearTimeout(timer);
  }, [deepLink]);

  return (
    <div className="payment-status-page">
      <div className={`payment-status-card payment-status-${status}`}>
        <div className="payment-status-icon">{content.icon}</div>
        <h1 className="payment-status-title">{content.title}</h1>
        <p className="payment-status-message">{content.message}</p>

        {(paymentId || orderId) && (
          <div className="payment-status-details">
            {paymentId && (
              <div>
                <span>Payment ID</span>
                <strong>{paymentId}</strong>
              </div>
            )}
            {orderId && (
              <div>
                <span>Order ID</span>
                <strong>{orderId}</strong>
              </div>
            )}
          </div>
        )}

        <a className="payment-status-btn primary" href={deepLink}>
          Open JapaKing App
        </a>
        {/* <button
          type="button"
          className="payment-status-btn secondary"
          onClick={() => navigate(status === "success" ? "/" : (window.ReactNativeWebView ? "/AppView" : "/plans"), { replace: true })}
        >
          {status === "success" ? "Continue on Web" : "Back to Plans"}
        </button> */}

        <p className="payment-status-support">
          Need help? Contact ishan@erishsolutions.com
        </p>
      </div>
    </div>
  );
}

export default PaymentStatus;
